// 所有地面站浮层共用可用高度；bottomLimit 已包含即时操作框上方的安全间距。
export function resolveGroundStationPopoverLayout ({ targetTop, naturalHeight, viewportTop, viewportBottom, bottomLimit, stackFromTop = false }) {
  const bottom = Math.max(viewportTop, Math.min(viewportBottom, Number.isFinite(bottomLimit) ? bottomLimit : viewportBottom))
  const top = Math.min(bottom, Math.max(viewportTop, stackFromTop ? targetTop : Math.min(targetTop, bottom - naturalHeight)))
  const maxHeight = Math.max(0, bottom - top)
  return { top, maxHeight, height: Math.min(naturalHeight, maxHeight) }
}
